import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Form, Alert } from 'react-bootstrap';
import { useSession } from '../App';

const LoginPage = () => {
    const navigate = useNavigate();
    const { login } = useSession();
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    // Hardcoded users
    const VALID_USERS = {
        'admin': {
            password: 'alani360',
            route: '/private/index',
            userType: 'admin'
        },
        'globalshopex': {
            password: 'gshopex',
            route: '/privategx/orders',
            userType: 'globalshopex'
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (error) setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            // Simulate API call delay
            await new Promise(resolve => setTimeout(resolve, 500));

            const { username, password } = formData;
            const user = VALID_USERS[username];

            if (!user || user.password !== password) {
                setError('Invalid username or password');
                return;
            }

            // Generate auth token (in real app, this would come from backend)
            const authToken = `token_${username}_${Date.now()}`;

            // Store auth token and user info
            localStorage.setItem('authToken', authToken);
            localStorage.setItem('userType', user.userType);
            localStorage.setItem('username', username);

            // Set authentication state
            login();

            // Redirect based on user type
            navigate(user.route);

        } catch (err) {
            setError('Login failed. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
            <Row className="w-100">
                <Col md={6} className="mx-auto">
                    <Card className="shadow">
                        <Card.Header className="bg-primary text-white text-center">
                            <h3 className="mb-0">MELI Integration</h3>
                        </Card.Header>
                        <Card.Body className="p-4">
                            <div className="text-center mb-4">
                                <h4>ALANI360 - MELI Integration</h4>
                            </div>

                            {error && (
                                <Alert variant="danger" className="mb-3">
                                    {error}
                                </Alert>
                            )}

                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        value={formData.username}
                                        onChange={handleInputChange}
                                        placeholder="Enter username"
                                        required
                                        disabled={isLoading}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                        placeholder="Enter password"
                                        required
                                        disabled={isLoading}
                                    />
                                </Form.Group>

                                <div className="d-grid">
                                    <Button
                                        type="submit"
                                        variant="primary"
                                        size="lg"
                                        disabled={isLoading}
                                        className="mb-3"
                                    >
                                        {isLoading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" />
                                                Logging in...
                                            </>
                                        ) : (
                                            'Login'
                                        )}
                                    </Button>
                                </div>
                            </Form>


                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default LoginPage;
